"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_publish-post-notice.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function PublishPostNotice(_ref) {
  var visible = _ref.visible,
      onClose = _ref.onClose,
      onSave = _ref.onSave;
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "publish-post-notice"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.BaseModal, {
      visible: visible,
      onClose: onClose,
      onSave: onSave
    }, /*#__PURE__*/_react.default.createElement("h3", null, "Do you want to Publish this post to Inspirations now?"), /*#__PURE__*/_react.default.createElement("p", null, 'If not your post will be saved as a ', /*#__PURE__*/_react.default.createElement("b", null, "Draft"), ' and won\'t be shown in the Inspirations App'), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      className: "publish-post-notice__add-btn",
      small: true,
      onClick: onSave
    }, "OKAY"), /*#__PURE__*/_react.default.createElement(_uiKit.LinkButton, {
      className: "publish-post-notice__later-btn",
      onClick: onClose
    }, "MAYBE LATER")))
  );
}

var _default = (0, _react.memo)(PublishPostNotice);

exports.default = _default;